const STORAGE_KEY = "ck-start-popup-shown"

type Stored = Record<string, string>

function todayLocal(): string {
    const d = new Date()
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, "0")
    const day = String(d.getDate()).padStart(2, "0")
    return `${y}-${m}-${day}`
}

function read(): Stored {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        return raw ? (JSON.parse(raw) as Stored) : {}
    } catch {
        return {}
    }
}

function write(data: Stored) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

/** Баннер уже показывали сегодня для этого кинотеатра */
export function wasStartPopupShownToday(cinemaId: number): boolean {
    return read()[String(cinemaId)] === todayLocal()
}

/** Запомнить закрытие баннера до следующих суток (локальное время) */
export function markStartPopupShown(cinemaId: number): void {
    const data = read()
    data[String(cinemaId)] = todayLocal()
    write(data)
}
